export default "__VITE_ASSET__uyfVnL7u__"